import React from "react";
import { IconStatus } from '../../components/IconStatus/IconStatus';
import { ILinkIconStatus } from '../../interfaces/Components/LinkIconStatus/ILinkIconStatus';
import { Link } from 'react-router-dom';

export const LinkIconStatus: React.FC<ILinkIconStatus> = ({ link, onClickHandler, ...props }) => {

    return (
        <>
            <Link to={link} onClick={onClickHandler}>
                <IconStatus {...props} />
            </Link>
        </>
    );
};
